export const EXPERTISE_LEVEL_NAMES = {
  ADVANCED: 'Продвинутый',
  MIDDLE: 'Средний',
  BASIC: 'Базовый',
} as const;

export const DEFAULT_RANGE_LABELS = {
  ADVANCED: '> 80%',
  MIDDLE: '50% - 80%',
  BASIC: '0% - 50%',
} as const;

// Контракт data-shape отчёта (ключи senior/middle/junior — legacy API).
export interface LevelNames {
  senior: string;
  middle: string;
  junior: string;
}

export interface LevelRangeLabels {
  senior: string;
  middle: string;
  junior: string;
}
